import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    dialogContent: {
      padding: "24px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    dialogTitle: {
      fontSize: "24px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    contactInfoContainer: {
      marginBottom: "16px",
    },
    linkOfferButton: {
      marginTop: "16px",
      alignSelf: "flex-end",
    },
    dialogWrapper: {
      maxWidth: "800px",
      width: "100%",
    },
    fieldsSection: {
      "&  > * + *": {
        marginTop: "20px",
        paddingTop: "20px",
      },
      "& label": {
        minWidth: "190px",
      },
      "& .FBFieldWrapper": {
        width: "100%",
      },
      "& .text-field-wrapper > div": {
        width: "100% !important",
      },
      "& .autocomplete": {
        width: "100% !important",
      },
    },
    optionWrapper: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      gap: "24px",
    },
    name: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "200px",
      display: "block",
    },
    languages: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    popoverClasses: {
      width: "700px !important",
    },
    selectedAgentsSection: {
      gap: "16px",
      display: "flex",
      alignItems: "center",
    },
  };
});
